import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useCookies } from 'react-cookie';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import { Typography } from '@mui/material';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

import MoreIcon from '@mui/icons-material/MoreVert';

import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { cyan } from '@mui/material/colors';

import ModalEditarUsuarios from "../modals/ModalEditarUsuarios";
import ModalAgregarUsuarios from "../modals/ModalAgregarUsuario";

import { useUser } from "../context/UserContext";
import SpeedDialTooltipOpen from "../components/SpeedDial";

const theme = createTheme({
    typography: {
        fontSize: 18, // Cambia la escala base de la tipografía (16px por defecto)
    },
    palette: {
        primary: cyan,
        secondary: {
            main: '#81c784',
        },
        white: {
            main: "#000000",
            light: "#000000",
            dark: "#000000",
            contrastText: "#000000",
        },
        white2: {
            main: "#ffffff",
            light: "#ffffff",
            dark: "#ffffff",
            contrastText: "#ffffff",
        }
    },
});

function Usuarios(params) {
    axios.defaults.withCredentials = true;
    const alerta = (mensage, icon) => {
        Swal.close();
        Swal.fire({
            title: mensage,
            icon: icon,
            text: "",
            showConfirmButton: false,
            timer: 1500
        });
    };

    const cargando = (mensage) => {
        Swal.fire({
            title: mensage + '...',
            didOpen: () => {
                Swal.showLoading();
            },
            allowOutsideClick: false,
            showConfirmButton: false,
        });
    };

    const [cookies, setCookie] = useCookies();
    const { user, logout } = useUser();

    const [usuarios, setUsuarios] = useState(null);
    const [proyectos, setProyectos] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (usuarios === null) {
            fetchUsuarios();
        }
        if (proyectos === null) {
            fetchProyectos();
        }
    }, []);

    const fetchUsuarios = async () => {
        cargando("Cargando usuarios");
        if (cookies.rol == "admin") {
            try {
                const response = await axios.get(
                    "https://apimedidas.ahouseinterior.com/ver_usuarios.php",
                    { headers: { "Content-Type": "application/json" } }
                );

                if (response.data && response.data.status === "success") {
                    alerta("Usuarios Cargados", "success");
                    setUsuarios(response.data.usuarios);
                    setError(null);
                } else {
                    alerta("No se pudo obtener la lista de Usuarios.", "error");
                    setError("No se pudo obtener la lista de Usuarios.");
                }
            } catch (err) {
                alerta("Ocurrió un error al conectar con el servidor.", "error");
                setError("Ocurrió un error al conectar con el servidor.");
            } finally {
                setLoading(false);
            }
        } else {
            alerta("No se como estas aqui, no eres Administrador", "error");
        }
    };

    const fetchProyectos = async () => {
        try {
            const response = await axios.get("https://apimedidas.ahouseinterior.com/obtener_proyectos.php", {
                withCredentials: true,
            });

            if (response.data.status === "success") {
                setProyectos(response.data.proyectos);
            } else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: 'No se pudo obtener la lista de proyectos',
                });
            }
        } catch (error) {
            console.error("Error al obtener proyectos:", error);
        }
    };

    const cambiarPermiso = async (tipo, proyecto_id, usuario_id) => {
        cargando("Cambiando permiso");
        try {
            const response = await axios.post('https://apimedidas.ahouseinterior.com/cambiar_permiso.php',
                {
                    proyecto_id: proyecto_id,
                    usuario_id: usuario_id,
                    cambio: tipo
                });

            if (response.data.status === 'success') {
                fetchUsuarios();
            } else {
                console.error('Error:', response.data.message);
            }
        } catch (error) {
            console.error('Error al actualizar permisos:', error);
        }
    };

    const editarUsuario = async (usuario) => {
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/editar_usuario.php",
                usuario,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            if (response.data.status === "success") {
                fetchUsuarios();
                Swal.fire({
                    title: "Usuario Editado",
                    text: `El usuario ${response.data.usuario.nombre} fue editado correctamente.`,
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: response.data.message || "No se pudo editar el usuario.",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false,
                });

                return null;
            }
        } catch (error) {
            console.error("Error al editar el usuario:", error);
            Swal.fire({
                title: "Error",
                text: "Ocurrió un error al conectar con el servidor.",
                icon: "error",
                timer: 1500,
                showConfirmButton: false,
            });
            return null;
        }
    };

    return (
        <div className="App">
            <ThemeProvider theme={theme}>
                <CssBaseline />

                <AppBar position="fixed" color="white2" sx={{ top: '0', bottom: "auto", width: '100%', height: "80px", padding: "10px 0px" }}>
                    <Grid container spacing={2} rowSpacing={0} columns={10}>
                        <Grid size={10} style={{ display: "flex", alignItems: "center", paddingLeft: "20px" }}>
                            <Typography color="white" style={{ marginRight: "10px" }}>{usuarios ? usuarios.length : 0}  </Typography>
                            <Typography color="primary"> Usuarios</Typography>
                        </Grid>
                        <Grid size={10} style={{ display: "flex", alignItems: "center", paddingLeft: "20px" }}>
                            <Typography color="white" variant="subtitle2"> Configuracion</Typography>
                        </Grid>
                    </Grid>

                    <SpeedDialTooltipOpen />
                </AppBar>

                <Grid style={{ marginBottom: "90px", marginTop: "90px", padding: "20px" }} container spacing={2} rowSpacing={2} columns={10}>

                    {usuarios &&

                        usuarios.map((usuario, index) => (

                            <Grid size={10} key={index}>
                                <Paper style={{ padding: "10px" }} >
                                    <Grid container spacing={2} rowSpacing={1} columns={10} >
                                        <Grid size={8}>
                                            <Typography variant="subtitle1" color={usuario.id == cookies.user ? "secondary" : "primary"}>{usuario.nombre} [{usuario.rol}]</Typography>
                                            <Typography variant="p">{usuario.email}</Typography>
                                        </Grid>
                                        <Grid size={2}>
                                            <ModalEditarUsuarios
                                                usuario={usuario}
                                                fetchUsuarios={fetchUsuarios}
                                                alerta={alerta}
                                                cargando={cargando}
                                                cambiarPermiso={cambiarPermiso}
                                                editarUsuario={editarUsuario}
                                                proyectos={proyectos}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        ))
                    }

                </Grid>

                <AppBar position="fixed" color="white" sx={{ top: 'auto', bottom: 0, width: '100%' }}>
                    <Toolbar>
                        <ModalAgregarUsuarios
                            fetchUsuarios={fetchUsuarios}
                            alerta={alerta}
                        />
                    </Toolbar>
                </AppBar>

            </ThemeProvider>
        </div>
    );
}

export default Usuarios;
